/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base, ApiPrefix } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetFactoryFiles = async (id, params = {}) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/factories/${id}/documents?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateFactoryFolder = async (id, data) => {
  return Request.call({
    url: `/micro/factories/${id}/folder`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDeleteFactoryFiles = async (id, data) => {
  return Request.call({
    url: `/micro/factories/${id}/documents`,
    method: 'DELETE',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiFactoryUploadFileToFolder = async (id, data) => {
  return Request.call({
    url: `/micro/factories/${id}/documents`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiFactoryMoveFileFolderV2 = async (id, data) => {
  return Request.call({
    url: `/micro/factories/${id}/documents`,
    method: 'PATCH',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSharedFactoryDocumentToken = async (id, data) => {
  return Request.call({
    url: `/micro/factories/${id}/documents/shared`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiRenameFactoryFolder = async (id, folderId, data) => {
  return Request.call({
    url: `/micro/factories/${id}/folder/${folderId}`,
    method: 'PATCH',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiVerifyFactoryFiles = async (factoryId, fileId, data = {}) => {
  return Request.call({
    url: `/micro/factories/${factoryId}/documents/${fileId}/verified`,
    data,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDuplicateFactory = async (id) => {
  return Request.call({
    url: `/micro/factories/${id}/duplicate`,
    method: 'POST',
    data: {},
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
